module.exports = __webpack_public_path__ + "static/media/caro_img_3.2986e6c0.jpeg";